import dompurify from 'dompurify';

angular.module('shared').directive('htmlContainer', function() {
  return {
    restrict: 'E',
    scope: {
      html: '='
    },
    template: '<div class="html-container" ng-bind-html="content"></div>',
    controller: ["$scope", "$sce", function($scope, $sce) {
      return $scope.$watch('html', function(val) {
        var purifiedContent;
        purifiedContent = dompurify.sanitize(val.replaceAll('\n', '<br/>'), {
          ADD_ATTR: ['target', 'alt']
        });
        return $scope.content = $sce.trustAsHtml(purifiedContent);
      });
    }]
  };
});
